import { SelectorValueTypes } from '../../../../types/enums/SelectorValueTypes';
import { SfdcDisplayType } from '../../../../types/fields';
import { SweepFieldsValueSelector } from '../../../SweepFieldsValueSelector/SweepFieldsValueSelector';
import { AutomationActionRowProps } from '../types';

export const LiteralSelect = ({
  readonly,
  onChange,
  _field,
  crmOrgId,
  _valueType,
  sfDisplayType,
}: Pick<AutomationActionRowProps, 'readonly' | 'onChange' | 'crmOrgId'> & {
  _field: AutomationActionField;
  _valueType: SelectorValueTypes;
  sfDisplayType?: SfdcDisplayType;
}) => {
  return (
    <SweepFieldsValueSelector
      isPicklistMultiple={sfDisplayType === SfdcDisplayType.PICKLIST ? false : undefined}
      placeholder="Value"
      shouldBeDisabled={!_field._fieldIds.length || readonly}
      parentSfDisplayType={sfDisplayType}
      initialValue={_field.value}
      onChange={(value) => {
        onChange({
          ..._field,
          value: value,
          valueType: _valueType,
        });
      }}
      fieldIds={_field._fieldIds}
      crmOrgId={crmOrgId}
      valueType={_field.valueType || _valueType}
    />
  );
};
